module.exports = __webpack_public_path__ + "img/SefanBachmann_140x140.bea5b728.jpg";